module.exports = __webpack_public_path__ + "static/img/HY-S3.986b0b45.png";